import { render, staticRenderFns } from "./Marche.vue?vue&type=template&id=445fc9de&"
import script from "./Marche.vue?vue&type=script&lang=js&"
export * from "./Marche.vue?vue&type=script&lang=js&"
import style0 from "./Marche.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports